/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import headerConfig from '../config/header.config.json';
import footerConfig from '../config/footer.config.json';
import heroConfig from '../config/heroSection.config.json';
import aboutConfig from '../config/aboutSection.config.json';
import pricingConfig from '../config/pricingSection.config.json';
import clientConfig from '../config/clientSection.config.json';
import complianceConfig from '../config/complianceSection.config.json';
import platformConfig from '../config/platformSection.config.json';
import platformPortfolioConfig from '../config/platformPortfolioSection.config.json';
import teamConfig from '../config/teamSection.config.json';
import testimonialConfig from '../config/testimonialSection.config.json';
import featureConfig from '../config/featuresSection.config.json';
import contactConfig from '../config/contactSection.config.json';

export interface IStaticPageContentMethods extends IPluginMethodMap {
  getStaticPageContentSync(args: any): any;
}

export class StaticPageContentService implements IAgentPlugin {
  readonly methods: IStaticPageContentMethods;

  constructor() {
    this.methods = {
      getStaticPageContentSync: this.getProps.bind(this),
    };
  }

  getProps(args: any) {
    return {
      ...(headerConfig || {}),
      ...(footerConfig || {}),
      ...(heroConfig || {}),
      ...{ ...(this.getMainSectionProps({}) || {}) },
    };
  }
  private getMainSectionProps(args: any) {
    const _config: any = {
      mainSection: [],
    };
    _config.mainSection.push(aboutConfig);
    _config.mainSection.push(platformPortfolioConfig);
    _config.mainSection.push(platformConfig);
    _config.mainSection.push(featureConfig);
    _config.mainSection.push(complianceConfig);
    //_config.mainSection.push(pricingConfig);
    _config.mainSection.push(testimonialConfig);
    _config.mainSection.push(clientConfig);
    _config.mainSection.push(teamConfig);
    //_config.mainSection.push(contactConfig);

    return { ...(_config || {}) };
  }
}
